'use strict';

const Enum = require('./enum');
const { LockActions } = require('./locks');
const { MERCURY_LOG_ACTIONS } = require('./keypads');

exports.AccessStatuses = Object.create(Enum, {
  PENDING: { value: 'pending', enumerable: true },
  EXPIRED: { value: 'expired', enumerable: true },
  GRANTED: { value: 'granted', enumerable: true },
  DENIED: { value: 'denied', enumerable: true },
  COMPLETED: { value: 'completed', enumerable: true },
  ENDED: { value: 'ended', enumerable: true },
  REVOKED: { value: 'revoked', enumerable: true },
});

exports.CredentialStatuses = Object.create(Enum, {
  LOADING: { value: 'loading', enumerable: true },
  ERROR: { value: 'error', enumerable: true },
  LOADED: { value: 'loaded', enumerable: true },
  REVOKED: { value: 'revoked', enumerable: true },
});

module.exports.LockControlPartner = {
  actionToEvent: function(action) {
    switch (action) {
      case LockActions.UNLOCKED:
      case MERCURY_LOG_ACTIONS.KeypadOpen:
        return this.AccessEvents.UNLOCKED;
      case LockActions.LOCKED:
      case MERCURY_LOG_ACTIONS.KeypadClose:
      case MERCURY_LOG_ACTIONS.KeypadOneTouch:
        return this.AccessEvents.LOCKED;
      case 'dooropen':
        return this.AccessEvents.OPENED;
      case 'doorclosed':
        return this.AccessEvents.CLOSED;

      default:
        return null;
    }
  },
  AccessEvents: Object.create(Enum, {
    UNLOCKED: { value: 'Unlocked', enumerable: true },
    OPENED: { value: 'Opened', enumerable: true },
    LOCKED: { value: 'Locked', enumerable: true },
    CLOSED: { value: 'Closed', enumerable: true },
    JAMMED: { value: 'Jammed', enumerable: true },
    CREDENTIAL_SEEN: { value: 'CredentialSeen', enumerable: true },
    SERVICE_COMPLETED: { value: 'ServiceCompleted', enumerable: true },
    ACCESS_FAILED: { value: 'AccessFailed', enumerable: true },
    LOCKING_FAILED: { value: 'LockingFailed', enumerable: true },
    CREDENTIAL_ACTIVATED: { value: 'CredentialActivated', enumerable: true },
    CREDENTIAL_USED: { value: 'CredentialUsed', enumerable: true },
    CREDENTIAL_DEACTIVATED: { value: 'CredentialDeactivated', enumerable: true },
  }),

  ActivityFeedActions: Object.create(Enum, {
    SERVICE_STARTED: { value: 'service_started', enumerable: true },
    SERVICE_COMPLETED: { value: 'service_completed', enumerable: true },
    ACCESS_GRANTED: { value: 'access_granted', enumerable: true },
    ACCESS_REVOKED: { value: 'access_revoked', enumerable: true },
  }),

  RouteTypes: Object.create(Enum, {
    ACCESS_LIST: { value: 'ihs_access_list', enumerable: true },
    ACCESS_DETAILS: { value: 'ihs_access_details', enumerable: true },
    SETTINGS: { value: 'ihs_settings', enumerable: true },
    ACTIVITY_FEED: { value: 'activity_feed', enumerable: true },
  }),
};
